<template>
    <div
        class="widget-template-category rounded-lg border border-ui-lines p-3 lg:p-4 cursor-pointer group hover:shadow-focus-outer transition"
        data-testid="widget-template-category"
        @click="onSelectCategory"
    >
        <div class="w-full flex items-center gap-3 lg:gap-6">
            <div class="flex-center">
                <component
                    :is="categoryIcon"
                    class="iconCategory transition w-10 h-10 text-secondary-actions group-hover:text-active-elements"
                />
            </div>
            <div class="flex flex-col gap-2 justify-center flex-grow main-text-color">
                <div class="main-text-color text-xl font-semibold">
                    {{ $t(String(category.TemplatesCategoryNameContentTag)) || '- -' }}
                </div>
                <div v-if="category.CategoryDescription">
                    {{ category.CategoryDescription }}
                </div>
            </div>
            <div class="flex-center gap-2 text-primary-actions">
                <div class="text-base font-semibold">
                    {{ templatesListLength }}
                </div>
                <redesign-base-icon
                    name="ChevronRight"
                    :size="24"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IWidgetTemplateCategory } from '@/types/templates'
import { computed } from 'vue'
import i18n from '@/i18n'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

const props = defineProps<{
    category: IWidgetTemplateCategory
}>()
const emit = defineEmits([ 'select-category' ])

const categoryIcon = computed(() => {
    let iconName = props.category.CategoryImage?.split('.')[0] || '' // get rid of extension
    if (iconName.length > 2) {
        iconName = iconName.charAt(0).toUpperCase() + iconName.slice(1)
    }
    return 'Icon' + iconName
})

const templatesListLength = computed(() => {
    const _widgetsLen = props.category.templates?.length || 0
    const _text = _widgetsLen > 1 ? i18n.t('widget.widgets') : i18n.t('widget.widget')

    return `${_widgetsLen} ${_text}`
})

function onSelectCategory () {
    emit('select-category', props.category)
}
</script>
